import { WidgetWrapper } from '@core/widgets';
import { AppContextType } from './components/helpers';
import { StoryblockComponent } from './Storyblock';
/**
 * Top level Player widget component based on legacy storyblock
 */
export const Player = ({ initialParams, widgetParams }) => (<WidgetWrapper appContextType={AppContextType.EMBED_PLAYER_TYPE} initialParams={initialParams} widgetParams={widgetParams}>
    <StoryblockComponent />
  </WidgetWrapper>);
